/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDatasetCardStyles = makeStyles(theme => ({
  root: {
    minHeight: '130px',
    boxShadow: 'none',
    overflow: 'visible',
    backgroundColor: '#F6F7F8',
    position: 'relative',
    padding: '24px 10px 13px 13px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    color: theme.palette.text.primary,
    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: 400,
    width: '100%',
  },
  upper: {},
  lower: {
    marginTop: '20px',
  },
  title: {
    color: '#1F3F6D',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 'bold',
    maxWidth: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  titleLabel: {
    marginTop: '5px',
    display: 'flex',
    alignItems: 'center',
  },
  date: {},
  size: {},

  tooltip: {
    border: '1px solid #EEEEEE',
    backgroundColor: '#FFFFFF',
    borderRadius: '5px',
    padding: '9px 13px',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '15px',
    color: theme.palette.text.primary,
  },
  tooltipPlacementBottom: {
    margin: 0,
  },
  infoIcon: {
    width: '12px',
    height: '12px',
    marginLeft: '3px',
  },
}));
